var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuDot(_ref, svgRef) {
  var _ref2, _ref3, _ref4;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 10.166,
    cy: 5.90234,
    r: 1,
    fill: "#1A4338",
    style: (_ref2 = {
      fill: "#1A4338"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.166,
    cy: 10.9023,
    r: 1,
    fill: "#1A4338",
    style: (_ref3 = {
      fill: "#1A4338"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.166,
    cy: 15.9023,
    r: 1,
    fill: "#1A4338",
    style: (_ref4 = {
      fill: "#1A4338"
    }, _defineProperty(_ref4, "fill", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref4, "fillOpacity", 1), _ref4)
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDot);
export default __webpack_public_path__ + "static/media/menu_dot.673e1fce.svg";
export { ForwardRef as ReactComponent };